import { render, staticRenderFns } from "./BalancesPlanAdd.vue?vue&type=template&id=46996b4e&scoped=true&"
import script from "./BalancesPlanAdd.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46996b4e",
  null
  
)

export default component.exports